import {
    RELEVANCE_FILTER_I18N_KEYS
} from '../../../../../../features/home/components/comment-filter/constants/i18n/RelevanceFilteri18nConstants'

export const RELEVANCE_FILTER_I18N_EN = {
    [RELEVANCE_FILTER_I18N_KEYS.relevance_filter_button_label]: "Relevance",
    [RELEVANCE_FILTER_I18N_KEYS.relevance_filter_option]:       "Show relevant content only",
    [RELEVANCE_FILTER_I18N_KEYS.irrelevance_filter_option]:     "Show irrelevant content only"
}




// WEBPACK FOOTER //
// ./src/locales/en/features/home/components/comment-filter/relevance_filter.i18n.en.js